import { selectAppliedInferenceSet, selectClient } from '@client/model/selectors';
import { calculateMonthsBetweenYears } from '@shared';
import { useSelector } from 'react-redux';

/**
 * Custom hook that provides common LTC planning calculation parameters.
 * Centralizes the logic for getting years to LTC, contribution months, and cost projections.
 */
export function useLtcPlanningCalculations() {
  const client = useSelector(selectClient);
  const appliedInferenceSet = useSelector(selectAppliedInferenceSet);

  const { ltcAtYear, yearsTillLtc } = appliedInferenceSet;

  const projectedLtcCost = client.allPhaseCosts.allPhaseInflatedProfessionalShareCost;
  const projectedLtcCostWithoutInflation = client.allPhaseCosts.allPhaseProfessionalShareCost;

  const contributionStartYear = new Date().getFullYear();
  const contributionEndYear = ltcAtYear;
  const contributionMonthCount =
    calculateMonthsBetweenYears(contributionStartYear, contributionEndYear) || 1;

  return {
    yearsTillLtc,
    yearsTillLtcRounded: Math.round(yearsTillLtc),
    ltcAtYear,
    projectedLtcCost,
    projectedLtcCostWithoutInflation,
    contributionStartYear,
    contributionEndYear,
    contributionMonthCount,
  };
}

